export function formatHours(value: number, useDecimalFormatForHours: boolean): string {
  if (useDecimalFormatForHours) {
    return value.toFixed(2).toString();
  }

  const isNegative = value < 0;
  value = Math.abs(value);

  const hoursPart = Math.floor(value);
  const minutesPart = Math.round((value * 60) % 60);

  const hoursPartString =
    hoursPart < 10 ? `${hoursPart}` : hoursPart.toString();
  const minutesPartString =
    minutesPart < 10 ? `0${minutesPart}` : minutesPart.toString();

  return `${isNegative ? '-' : ''}${hoursPartString}:${minutesPartString}`;
}
